import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assign from "lodash/assign";

/**
 * An error occured during input validation
 * @example
 * // Constructed error converted to JSON:
 * {
 *   "name": "ValidationError",
 *   "errors": {
 *     "thing.requiredInput": ["This input is required"]
 *   }
 * }
 * @property {String} name ValidationError
 * @property {Object} errors Keys represent dot notation of the input that failed validation
 */
var ValidationError = /*#__PURE__*/_createClass(function ValidationError(message, errors) {
  _classCallCheck(this, ValidationError);

  _assign(this, {
    name: 'ValidationError',
    errors: errors,
    message: message,
    statusCode: 400,
    stack: new Error().stack
  });
});

export default ValidationError;